import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/**
 * Last line of defence. A thrown render error would otherwise leave the PWA on
 * a white screen with no way back, which on a phone means force-quitting.
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Unhandled render error', error, info.componentStack);
  }

  override render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="page-state page-state--error" role="alert">
        <h1>Hiba történt</h1>
        <p className="muted">{error.message}</p>
        <button type="button" className="button button--primary" onClick={() => location.reload()}>
          Újratöltés
        </button>
      </div>
    );
  }
}
